export default __webpack_public_path__ + "static/media/finances-off.ac7b7d06.png";